import React from 'react';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import { Zoom, Box } from '@mui/material';

const ScrollTop = (props) => {
  const { children } = props;

  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector(
      '#back-to-top-anchor'
    );

    if (anchor) {
      anchor.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  };

  return (
    <Zoom in={trigger}>
      <Box
        onClick={handleClick}
        role='presentation'
        sx={{ position: 'fixed', bottom: 16, right: 16, zIndex: 100 }}
      >
        {children}
      </Box>
    </Zoom>
  );
};

export default ScrollTop;
